import axios from "axios";
let link = "https://acadshr.sulonya.com";
const instituteLink = "https://acadshr.herokuapp.com";

export const signUpAPI = (data) => {
  return axios.post(`${link}/user`, data);
};
export const userLogin = (data) => {
  return axios.post(`${link}/user/login`, data);
};
export const updatePersonalDetails = (data) => {
  let token = localStorage.getItem("userToken");

  let config = {
    method: "post",
    url: `${link}/ahr/candidate/register/basic`,
    headers: {
      authorization: `Bearer ${token}`,
    },
    data: {
      ...data,
    },
  };
  return axios(config);
};

export const updateCandidateQualification = (data) => {
  let token = localStorage.getItem("userToken");

  let config = {
    method: "put",
    url: `${link}/ahr/candidate/qualification`,
    headers: {
      authorization: `Bearer ${token}`,
    },
    data: {
      ...data,
    },
  };
  return axios(config);
};

export const updateCandidateEmployment = (data) => {
  let token = localStorage.getItem("userToken");

  let config = {
    method: "put",
    url: `${link}/ahr/candidate/employment`,
    headers: {
      authorization: `Bearer ${token}`,
    },
    data: {
      ...data,
    },
  };
  return axios(config);
};

export const updateCandidatePreference = (data) => {
  let token = localStorage.getItem("userToken");

  let config = {
    method: "put",
    url: `${link}/ahr/candidate/preference`,
    headers: {
      authorization: `Bearer ${token}`,
    },
    data: {
      ...data,
    },
  };
  return axios(config);
};

export const uploadFile = (data) => {
  return axios.post(`https://sulonyafiles.sulonya.com/files/upload`, data);
};

export const updateInstituteBasicDetails = (data) => {
  let token = localStorage.getItem("userToken");

  let config = {
    method: "post",
    url: `${link}/ahr/institute/register/basic`,
    headers: {
      authorization: `Bearer ${token}`,
    },
    data: {
      ...data,
    },
  };
  return axios(config);
};

export const updateInstituteContactDetails = (data) => {
  let token = localStorage.getItem("userToken");
  let config = {
    method: "post",
    url: `${link}/ahr/institute/contact`,
    headers: {
      authorization: `Bearer ${token}`,
    },
    data: {
      ...data,
    },
  };
  return axios(config);
};

export const checkEmail = (data) => {
  return axios.post(`${link}/user/emailexist`, data);
};

export const uploadResume = (data, config) => {
  return axios.post(`${link}/upload`, data, config);
};
export const updateCandidateResume = (data) => {
  let token = localStorage.getItem("userToken");
  let config = {
    method: "put",
    url: `${link}/ahr/candidate/resume`,
    headers: {
      authorization: `Bearer ${token}`,
    },
    data: {
      ...data,
    },
  };
  return axios(config);
};

export const createCollege = (data) => {
  let token = localStorage.getItem("userToken");
  let config = {
    method: "post",
    url: `${link}/admin/college`,
    headers: {
      authorization: `Bearer ${token}`,
    },
    data: {
      ...data,
    },
  };
  return axios(config);
};
export const createUniversity = (data) => {
  let token = localStorage.getItem("userToken");
  let config = {
    method: "post",
    url: `${link}/admin/university`,
    headers: {
      authorization: `Bearer ${token}`,
    },
    data: {
      ...data,
    },
  };
  return axios(config);
};
export const createSpecialization = (data) => {
  let token = localStorage.getItem("userToken");
  let config = {
    method: "post",
    url: `${link}/admin/course/specialization`,
    headers: {
      authorization: `Bearer ${token}`,
    },
    data: {
      ...data,
    },
  };
  return axios(config);
};
export const createCourse = (data) => {
  let token = localStorage.getItem("userToken");
  let config = {
    method: "post",
    url: `${link}/admin/course`,
    headers: {
      authorization: `Bearer ${token}`,
    },
    data: {
      ...data,
    },
  };
  return axios(config);
};

export const updatePassword = (data) => {
  let token = localStorage.getItem("userToken");
  let config = {
    method: "put",
    url: `${link}/user/updatePassword`,
    headers: {
      authorization: `Bearer ${token}`,
    },
    data: {
      ...data,
    },
  };
  return axios(config);
};
export const saveJobCandidate = (data) => {
  let token = localStorage.getItem("userToken");
  let config = {
    method: "post",
    url: `${link}/candidate/jobs/saveJob`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      ...data,
    },
  };
  return axios(config);
};
export const getAllSavedJobs = (data) => {
  console.log("saved", data);
  let token = localStorage.getItem("userToken");

  let config = {
    method: "post",
    url: `${link}/candidate/jobs/getSavedJob`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      ...data,
    },
  };
  return axios(config);
};
export const unSaveJobCandidate = (data) => {
  let token = localStorage.getItem("userToken");
  let config = {
    method: "post",
    url: `${link}/candidate/jobs/deleteSavedJob`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      ...data,
    },
  };
  return axios(config);
};

export const editQualification = (userId, qualificationId, data) => {
  let token = localStorage.getItem("userToken");
  let config = {
    method: "put",
    url: `${link}/ahr/candidate/update/${userId}/qualification/${qualificationId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      ...data,
    },
  };
  return axios(config);
};

export const editEmployment = (userId, employmentId, data) => {
  let token = localStorage.getItem("userToken");
  let config = {
    method: "put",
    url: `${link}/ahr/candidate/update/${userId}/employment/${employmentId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      ...data,
    },
  };
  return axios(config);
};

export const requestForgotPassword = (data) => {
  return axios.post(`${link}/user/resetPasswordRequest`, data);
};

export const resetForgotPassword = (data) => {
  return axios.post(`${link}/user/resetPassword`, data);
};

export const getAppliedJobs = (jobId, data) => {
  console.log("job", data);
  let token = localStorage.getItem("userToken");
  let config = {
    method: "post",
    url: `${link}/candidate/jobs/assigned/${jobId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      ...data,
    },
  };
  return axios(config);
};

export const applyJob = (jobId, userId) => {
  let token = localStorage.getItem("userToken");
  let config = {
    method: "post",
    url: `${link}/candidate/jobs/${jobId}/candidate/${userId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

export const updateProfileNew = (id, data) => {
  let token = localStorage.getItem("userToken");
  let config = {
    method: "put",
    url: `${link}/ahr/institute/${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      ...data,
    },
  };
  return axios(config);
};

export const searchJobAPI = (data) => {
  return axios.post(`${link}/candidate/jobs/search/4`, data);
};

export const updateWorkingStatus = (data) => {
  let token = localStorage.getItem("userToken");
  let config = {
    method: "put",
    url: `${link}/ahr/candidate/workstatus`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      ...data,
    },
  };
  return axios(config);
};

export const updateSkills = (data) => {
  let token = localStorage.getItem("userToken");
  let config = {
    method: "put",
    url: `${link}/ahr/candidate/skill`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      ...data,
    },
  };
  return axios(config);
};

export const contactUsAPI = (data) => {
  return axios.post(`${link}/admin/product_management/contactus`, { ...data });
};

// added by uzhairkhan

export const instituteLogin = (data) => {
  return axios.post(`${instituteLink}/user/login`, data);
};
export const createJobPost = (data) => {
  let token = localStorage.getItem("userToken");
  let config = {
    method: "post",
    url: `${instituteLink}/ahr/job`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      ...data,
    },
  };
  return axios(config);
};
export const getAllInstituteJobsPost = (data) => {
  let token = localStorage.getItem("userToken");

  let config = {
    method: "post",
    url: `${instituteLink}/ahr/job/list`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      ...data,
    },
  };
  return axios(config);
};
export const getJobById = (id) => {
  let token = localStorage.getItem("userToken");
  let config = {
    method: "get",
    url: `${instituteLink}/ahr/job/${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
export const updateJobPost = (id, data) => {
  let token = localStorage.getItem("userToken");
  let config = {
    method: "put",
    url: `${instituteLink}/ahr/job/${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      ...data,
    },
  };
  return axios(config);
};
// added by uzhairkhan
